import {
  ErrorComponent,
  Link,
  rootRouteId,
  useMatch,
  useRouter,
} from '@tanstack/react-router'
import type { ErrorComponentProps } from '@tanstack/react-router'
import cn from 'classnames'

export function DefaultCatchBoundary({ error, ...props }: ErrorComponentProps<Error>) {
  const router = useRouter()
  const isHome = useMatch({
      strict: false,
      select: (state) => state.id === '/',
  })
  const isRoot = useMatch({
    strict: false,
    select: (state) => state.id === rootRouteId,
  })

  return (
    <div className="min-w-0 flex-1 p-4 flex flex-col items-center justify-center gap-6">
      {/*<ErrorComponent error={error} />*/}
      <p>Something went wrong</p>
      <div className="flex gap-2 items-center flex-wrap">
        <button
          onClick={() => {
            router.invalidate()
          }}
          className={cn('btn btn-accent btn-dash')}
        >
          Try Again
        </button>
        {!isHome && (
          <Link
            to="/"
            className={cn('btn btn-accent btn-dash')}
          >
            Home
          </Link>
        )}
        {!isHome && !isRoot && (
          <Link
            to="/"
            className={cn('btn btn-accent btn-dash')}
            onClick={(e) => {
              e.preventDefault()
              window.history.back()
            }}
          >
            Go Back
          </Link>
        )}
      </div>
    </div>
  )
}
